import DashboardStore from "./Dashboard/DashboardStore";
// Legacy AIAgentStore retired in favor of @intrasync/ai-agent's AgentHub stores
// (registered via src/views/aiAgent/aiAgentStoreList.ts).

const administrationStoreList = [
    { name: "dashboardStore", store: DashboardStore },
];

export default administrationStoreList;
